import { IPlayflowPlay } from './playflow';

export interface IMessageHeader {
  messageType: number;
  scout: string;
  clientTimestamp: string;
}

export interface IMessageBody {
  gameId: number;
  gameState?: IGameState;
  play?: IPlayflowPlay;
  events?: IEvent[];
  roster?: IGameRoster;
  teams?: IGameTeams;
}

export interface IGameTeams {
  home: number;
  away: number;
}

export interface IGameMessage {
  header: IMessageHeader;
  body: IMessageBody;
}

export interface IGameClock {
  minutes: number;
  seconds: number;
}

interface IGameRoster {
  homePlayers: ITeamRoster;
  awayPlayers: ITeamRoster;
}

interface ITeamRoster {
  passer: IRosterPlayer[];
  rushers: IRosterPlayer[];
  receivers: IRosterPlayer[];
}

export interface IRosterPlayer {
  playerId: number;
  firstName: string;
  lastName: string;
  jersey: string;
}

export interface IGameState {
  gameStatusId: number;
  quarter: number;
  gameClock: IGameClock;
  clockIsRunning: boolean;
  awayTeamScore: number;
  homeTeamScore: number;
  awayTeamTimeoutsLeft: number;
  homeTeamTimeoutsLeft: number;
  hasMediaDelay: boolean;
}

export interface IGame {
  gameId: number;
  gameState: IGameState;
  plays: IPlayflowPlay[];
  events?: IEvent[];
}

export interface IEvent {
  eventTypeId: number;
  value: number | boolean | string;
}

export enum TMessageType {
  GAME_UPDATE = 1,
  HEARTBEAT = 2,
}

export enum TUserRole {
  ALL = 'ALL',
  CLOCK = 'CLOCK',
  PLAYS = 'PLAYS',
}

export type TQueuedGameState = IGameState & { gameId: number; clientTimestamp: string };
export type TQueuedPlayFlowPlay = IPlayflowPlay & { gameId: number; clientTimestamp: string };

export interface IQueueManager {
  pendingGameStateUpdate: TQueuedGameState | null;
  activeGameStateUpdate: TQueuedGameState | null;
  gameStateEvents: IEvent[] | null;
  isProcessingGameState: boolean;
  pendingPlayflowUpdate: TQueuedPlayFlowPlay[];
  isProcessingPlayflowPuts: boolean;
  pendingPlayflowPuts: TQueuedPlayFlowPlay[];
  activePlayflowUpdate: TQueuedPlayFlowPlay[];
  isProcessingPlays: boolean;
}

export enum TQueueType {
  PLAY = 'PLAY',
  PLAY_PUT = 'PLAY_PUT',
  GAME = 'GAME',
}
